var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('formNotification'),(this.ifRegionalUser)?_c('comRcNu',{attrs:{"nuToRc":""}}):_c('comAtNu',{attrs:{"nuToRc":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }